var map = {
	"./reference1-1-2.webp": 8228,
	"./reference2-1-1.webp": 1849,
	"./reference3-1-1.webp": 7296,
	"./reference4-2-2.webp": 4432,
	"./reference5-1-1.webp": 4365,
	"./reference6-1-1.webp": 1271,
	"./reference7-1-1.webp": 6070,
	"./reference8-1-1.webp": 4823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;